import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

function buildRsvpUrl(): string {
  if (weddingConfig.rsvpType === 'whatsapp' && weddingConfig.rsvpWhatsappNumber) {
    const message = weddingConfig.rsvpMessage
      .split('[BRIDE NAME]')
      .join(weddingConfig.brideName)
      .split('[GROOM NAME]')
      .join(weddingConfig.groomName);
    return `https://wa.me/${weddingConfig.rsvpWhatsappNumber}?text=${encodeURIComponent(message)}`;
  }
  return weddingConfig.rsvpUrl;
}

export default function RSVP() {
  const rsvpUrl = buildRsvpUrl();

  return (
    <section className="relative w-full bg-primary-50 py-20 md:py-28">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <ScrollReveal>
          <p className="micro-label mb-6 text-primary-700">Confirma tu asistencia</p>
          <div className="mx-auto h-px w-16 bg-primary-300" />
        </ScrollReveal>

        <ScrollReveal delay={1}>
          <p className="mx-auto mt-10 max-w-md font-heading text-lg italic leading-relaxed text-foreground-600 sm:text-xl md:text-2xl">
            Será muy especial compartir este día contigo.
          </p>
        </ScrollReveal>

        {weddingConfig.rsvpDeadline && (
          <ScrollReveal delay={2}>
            <p className="mt-6 font-body text-sm text-foreground-500 sm:text-base">
              Confirma tu asistencia antes del{' '}
              <span className="text-primary-700">{weddingConfig.rsvpDeadline}</span>.
            </p>
          </ScrollReveal>
        )}

        <ScrollReveal delay={2}>
          <div className="mt-14 md:mt-16">
            <a
              href={rsvpUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              <i className="ri-checkbox-circle-line text-base" />
              Confirmar asistencia
            </a>
          </div>
        </ScrollReveal>

        {weddingConfig.contactInfo && (
          <ScrollReveal delay={3}>
            <p className="mt-10 font-body text-xs text-foreground-400 sm:text-sm">
              {weddingConfig.contactInfo}
            </p>
          </ScrollReveal>
        )}
      </div>
    </section>
  );
}